'use strict';
// Announcement close
var ann=document.getElementById('rzxAnn'),annClose=document.getElementById('rzxAnnClose'),hdr=document.getElementById('rzxHdr');
if(annClose&&ann){annClose.addEventListener('click',function(){ann.style.display='none';if(hdr)hdr.classList.add('ann-off')});}

// Mobile menu
var mobToggle=document.getElementById('rzxMobToggle'),mobPanel=document.getElementById('rzxMobPanel'),mobBg=document.getElementById('rzxMobBg'),mobClose=document.getElementById('rzxMobClose');
function openMob(){if(mobPanel)mobPanel.classList.add('open');if(mobBg)mobBg.classList.add('open');if(mobToggle)mobToggle.setAttribute('aria-expanded','true');}
function closeMob(){if(mobPanel)mobPanel.classList.remove('open');if(mobBg)mobBg.classList.remove('open');if(mobToggle)mobToggle.setAttribute('aria-expanded','false');}
if(mobToggle)mobToggle.addEventListener('click',openMob);
if(mobClose)mobClose.addEventListener('click',closeMob);
if(mobBg)mobBg.addEventListener('click',closeMob);
document.querySelectorAll('#rzxMobPanel a').forEach(function(a){a.addEventListener('click',closeMob);});

// FAQ
document.querySelectorAll('.faq__q').forEach(function(btn){
  btn.addEventListener('click',function(){
    var item=btn.parentElement,open=item.classList.toggle('open');
    btn.setAttribute('aria-expanded',open);
  });
});

// Hero parallax
var heroVis=document.getElementById('rzxHeroVis'),heroImg=document.getElementById('rzxHeroImg');
if(heroVis&&heroImg){
  heroVis.addEventListener('mousemove',function(e){
    var r=heroVis.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
    heroImg.style.transform='rotateY('+(x*11)+'deg) rotateX('+(y*-9)+'deg) translateZ(12px)';
  });
  heroVis.addEventListener('mouseleave',function(){heroImg.style.transform='none';});
}

// Scroll reveal
var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting)e.target.classList.add('reveal-in');});},{threshold:0.1});
document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
